import { render, staticRenderFns } from "./TaxReturn.vue?vue&type=template&id=0b70b32e&scoped=true&"
import script from "./TaxReturn.vue?vue&type=script&lang=js&"
export * from "./TaxReturn.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturn.vue?vue&type=style&index=0&id=0b70b32e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70b32e",
  null
  
)

component.options.__file = "TaxReturn.vue"
export default component.exports